/*!
 * Copyright (c) REWE Digital GmbH
 */
import { Host, h } from "@stencil/core";
/**
 * Filter container component.
 */
export class VxLoadingSpinner {
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (h(Host, { key: '183bc7bc62b505336265d4ae3f6d40fe4f552b14' }, h("div", { key: '3a18ade466cf7443394cfb2eb54b3152e616379f', class: 'vx-loading-spinner' })));
    }
    static get is() { return "vx-loading-spinner"; }
    static get encapsulation() { return "scoped"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-loading-spinner.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-loading-spinner.css"]
        };
    }
}
//# sourceMappingURL=vx-loading-spinner.js.map
